import React, { useEffect } from 'react'
import {ReactComponent as Phone} from '../../assets/new-icons/phone.svg';
import {ReactComponent as Email} from '../../assets/new-icons/email.svg';
import {ReactComponent as Coffee} from '../../assets/new-icons/coffee.svg';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function Assistence() {
    useEffect(() => {
        document.body.style.overflow = null;
        document.body.style.touchAction = null;   
    },[])
    return (
        <div className="assistenceComponent">
            <div className="assHeader">
                <p className="main epilogue">
                    Hai bisogno di aiuto?
                </p>
                <p className="secondary">
                    Saremo pronti a rispondere a ogni tua domanda. Contattaci direttamente oppure prenota un appuntamento nell'orario a te più comodo!
                </p>
            </div>
            <div className="items">
                <div className="item" onClick={() => window.open(
                    'tel:+390890977647',
                     // <- This is what makes it open in a new window.
                )}>
                    <div className="icon">
                        <Phone />
                    </div>
                    <div className="text">
                        <p className="main">089 0977647</p>
                        <p className="secondary">Contattaci per ogni dubbio!</p>
                    </div>
                </div>
                <div className="item" onClick={() => window.open(
                    'mailto:info@revoluce.it',
                     // <- This is what makes it open in a new window.
                )}>
                    <div className="icon">
                        <Email />
                    </div>
                    <div className="text">
                        <p className="main">info@revoluce.it</p>
                        <p className="secondary">Scrivici per ogni perplessità.</p>
                    </div>
                </div>
                <div className="item">
                    <div className="icon">
                        <Coffee />
                    </div>
                    <div className="text">
                        <p className="main">Siamo a Salerno</p>
                        <p className="secondary">Via S. Leonardo - 51,<br/>Prendiamo un caffè?</p>
                    </div>
                </div>
            </div>
            <div className="tutor">
                <h2>Preferisci farti richiamare da un nostro tutor? </h2>
            </div>
            <button onClick={() => window.open(
                    'https://my.revoluce.it/appuntamento',
                    '_blank' // <- This is what makes it open in a new window.
                )}>Prenota un appuntamento <ArrowForwardIosIcon/></button>
        </div>
    )
}

export default Assistence
